<template>
  <div
    style="min-width: 0; flex:1 1 0"
    class="px-2"
  >
    <div
      class="d-flex align-center"
      v-for="(event, index) in filteredEvents"
      :key="index"
    >
      <span
        :style="{ '--news-font-size': fontSizeFormat }"
        class="event-title text--primary d-inline-block text-truncate mr-1"
        :class="fontsSetting.fontsize !== 'LG'? 'mt-2' : 'mt-1'"
      >
        <v-icon
          large
          style="width: 12px; height: 12px;"
          :color="index === 0 ? 'primary' : index === 1 ? 'grey darken-1' : 'grey darken-4'"
        >
          mdi-circle-small
        </v-icon>
        {{ event.title }}
      </span>
      <v-spacer></v-spacer>
      <span
        :style="{ '--news-font-size': fontsSetting.getFontSize * '10' + 'px' }"
        class="event-title text--disabled d-inline-block text-truncate"
      >
        {{ formatEventDate(event.date) }}
      </span>
    </div>
  </div>
</template>

<script>
import { mapState } from "pinia"
import { useSettingsStore } from "@/store/index";
import { useFxMarketStore } from "@/store/toolbarStore"
import * as utils from "@/utils/utils.js"

export default {
  data(){
    return {
      fontsSetting: useSettingsStore(),
      screenSize: window.innerWidth
    }
  },
  computed: {
    ...mapState(useFxMarketStore, [
      "getFxMarketEconomicCalendar",
    ]),
    convertedEvents() {
      if (!this.getFxMarketEconomicCalendar) return []
      return this.getFxMarketEconomicCalendar.map((event) => {
        let result = {}
        result["country"] = event.country

        let dateString = event.date.includes("T") ? event.date : `${event.date}T00:00:00Z`
        result["date"] = this.normalizeEventDate(dateString)
        result["indicator"] = event.indicator
        result["title"] = event.title
        return result
      })
    },
    sortedEvents() {
      return this.convertedEvents.slice().sort((a, b) => a.date - b.date)
    },
    filteredEvents() {
      const today = new Date().setHours(0, 0, 0, 0)
      const maxEvents = 3
      const maxDays = 10
      const foundEvents = []

      for (let dayOffset = 0; foundEvents.length < maxEvents && dayOffset < maxDays; dayOffset++) {
        const date = today + dayOffset * 86400000
        const event = this.findEventsForDate(date, this.sortedEvents)

        if (event) {
          foundEvents.push(event)
        }
      }

      return foundEvents
    },
        screenSizeFormat() {
      if (this.screenSize <= 1080) return "mobile";
      if (this.screenSize <= 1150) return "tablet";
      if (this.screenSize <= 1270) return "smallScreen";
      return "full";
    },
    fontSizeFormat(){
      if(this.fontsSetting.fontsize === 'SM' || this.fontsSetting.fontsize === 'MD' || this.fontsSetting.fontsize === 'LG'  ) {
        //
        if(this.screenSizeFormat === 'smallScreen') 
        {
          return this.fontsSetting.getFontSize * '11' + 'px';
        }
        else if (this.screenSizeFormat === 'full')
        {
          return this.fontsSetting.getFontSize * '13' + 'px';
        }

      }
      
    },
  },
  methods: {
    normalizeEventDate(dateString) {
      const { year, month, day } = utils.getDateParts(dateString)
    
      return new Date(`${year}-${month}-${day}T00:00:00`).getTime()
    },
    findEventsForDate(date, filterData) {
      const nextDate = date + 86400000
      
      const eventBR = filterData.find(
        (event) => event.country === 'BR' && event.date >= date && event.date < nextDate
      )
      
      const eventUS = filterData.find(
        (event) => event.country === 'US' && event.date >= date && event.date < nextDate
      )
      
      const eventEU = filterData.find(
        (event) => event.country === 'EU' && event.date >= date && event.date < nextDate
      )

      return eventBR || eventUS || eventEU || null
    },
    formatEventDate(eventDate) {
      const today = new Date().setHours(0, 0, 0, 0)
      const eventTime = new Date(eventDate).setHours(0, 0, 0, 0)
      const diffInDays = (eventTime - today) / (1000 * 60 * 60 * 24)

      if (diffInDays === 0) return this.$i18n.t('economicCalendar.today')
      else if (diffInDays === 1) return this.$i18n.t('economicCalendar.tomorrow')
      else {
        return new Intl.DateTimeFormat(this.$i18n.locale, {
          day: 'numeric',
          month: '2-digit'
        }).format(eventTime)
      }
    },
  }
}
</script>

<style scoped>
 .event-title{
  font-size: var(--news-font-size) !important;
  line-height: 1rem;
 }
</style>